/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, July 7th 2022, 9:59:17 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { APISERVICEPATHS, useAPIFetchList, useAPIForm, UseAPIFormSpec } from "lib/api";
import { ProcessStage, ProcessStageValidationSchema } from "lib/schemas";

/** ProcessStageAPI API */

const processStageAPI = APISERVICEPATHS.processStages;

export interface UseProcessStageAPIFormSpec {
  processStageFetchId?: ProcessStage["id"];
  processStageDefaultValues: ProcessStage;
  updateProcessStageFromAPICallback: UseAPIFormSpec<ProcessStage>["setAPIFormResponse"];
  onSuccessfulAPISave: () => void;
}

export const useProcessStageAPIAPIForm = ({
  processStageFetchId,
  processStageDefaultValues,
  updateProcessStageFromAPICallback,
  onSuccessfulAPISave,
}: UseProcessStageAPIFormSpec) => {
  const useAPIFormReturn = useAPIForm({
    apiServicePath: processStageAPI,
    apiFormDataValidationSchema: ProcessStageValidationSchema,
    apiFormDefaultValues: processStageDefaultValues,
    apiInitialFetchId: processStageFetchId,
    primaryKey: "id",
    setAPIFormResponse: updateProcessStageFromAPICallback,
  });

  React.useEffect(() => {
    if (useAPIFormReturn.isSuccessfulAPIDataSend) onSuccessfulAPISave?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useAPIFormReturn.isSuccessfulAPIDataSend]);

  return useAPIFormReturn;
};

interface UseListProcessStagesAPISpec {
  processDefinitionId: ProcessStage["process"];
}

export const useListProcessStagesAPI = ({ processDefinitionId }: UseListProcessStagesAPISpec) =>
  useAPIFetchList<ProcessStage>({
    apiServicePath: processStageAPI,
    makeRequestOnInitialMount: false,
    apiQueryParams: { process_definition: processDefinitionId },
  });
